import React, { useState } from "react";
import { NavigateFunction } from "react-router-dom";
import { ProjectBasicDataType } from "../../interface/interface";
type Props = {
  data: any;
  navigate: NavigateFunction;
  category: "mtup" | "prjt" | undefined;
  __ChangeState:
    | ((
        type: "reject" | "select" | "block" | "reselect",
        data: any
      ) => Promise<boolean>)
    | undefined;
  prjtData: ProjectBasicDataType | undefined;
};

const FinishSelectCard = ({
  data,
  navigate,
  category,
  __ChangeState,
  prjtData,
}: Props) => {
  const {
    apply_usr_nm,
    apply_self_brif_1,
    apply_self_brif_2,
    // apply_sts_at,
    usr_email,
    login_id,
    apply_sts_cd,
    // prjt_sts_cd,
    apprv_sts_cd,
    usr_link,
    rcrt_nm,
  } = data;

  const [ActiveType, setActiveType] = useState<
    "reject" | "select" | "block" | "reselect" | undefined
  >(undefined);

  return (
    <div className="select-user-card">
      <div className="left">
        <div className="select-user-id">{login_id}</div>
        <div className="select-user-email">{usr_email}</div>
        <div className="select-user-time">{rcrt_nm}</div>
      </div>
      <div className="right">
        {category === "prjt" ? (
          <>
            <div className="prjt-btn-select-section">
              <>
                {(apply_sts_cd !== "apply_sts_cancel" &&
                  apprv_sts_cd !== "apprv_sts_reject") ||
                apprv_sts_cd === "apprv_sts_block" ? (
                  <>
                    <button
                      className="port-btn"
                      onClick={() => {
                        navigate("/portfolio/view", {
                          state: {
                            img: prjtData?.prjt_thumbnail,
                            type: prjtData?.prjt_type_cd,
                            prjt_nm: prjtData?.prjt_nm,
                            sub: apply_self_brif_1,
                            content: apply_self_brif_2,
                            link: usr_link,
                          },
                        });
                      }}
                    >
                      포트폴리오 보기
                    </button>
                    <button
                      className={`reject-btn ${
                        apply_sts_cd === "apply_sts_wait"
                          ? "wait"
                          : apprv_sts_cd === "apprv_sts_select"
                          ? "block"
                          : apprv_sts_cd === "apprv_sts_block"
                          ? "comback"
                          : ""
                      }-btn`}
                      onClick={() => {
                        setActiveType(
                          apply_sts_cd === "apply_sts_wait"
                            ? "reject"
                            : apprv_sts_cd === "apprv_sts_select"
                            ? "block"
                            : "reselect"
                        );
                      }}
                    >
                      {apply_sts_cd === "apply_sts_wait"
                        ? "거절하기"
                        : apprv_sts_cd === "apprv_sts_select"
                        ? "강퇴"
                        : apprv_sts_cd === "apprv_sts_block"
                        ? "복귀"
                        : ""}
                    </button>
                  </>
                ) : undefined}
                {apply_sts_cd === "apply_sts_wait" ? (
                  <button
                    className="select-btn"
                    onClick={() => {
                      setActiveType("select");
                    }}
                  >
                    선정하기
                  </button>
                ) : (
                  <div
                    className={`sts-text ${apply_sts_cd}-text  ${apprv_sts_cd}-text`}
                  >
                    {apprv_sts_cd === "apprv_sts_select"
                      ? "선정됨"
                      : apprv_sts_cd === "apprv_sts_block"
                      ? "강퇴처리"
                      : apply_sts_cd === "apply_sts_cancel"
                      ? "취소"
                      : apprv_sts_cd === "apprv_sts_reject"
                      ? "거절됨"
                      : "미선정"}
                  </div>
                )}
              </>
            </div>

            <div
              className={`common-delete-section ${
                ActiveType ? "common-delete-on" : ""
              } ${ActiveType}-section`}
            >
              <div className="delete-ment">
                {ActiveType === "reject"
                  ? "참여 거절 처리하시겠습니까?"
                  : ActiveType === "select"
                  ? "프로젝트 참여자로 선정하시겠습니까?"
                  : ActiveType === "block"
                  ? "참여자를 강퇴처리하시겠습니까?"
                  : "참여자를 복귀처리하시겠습니까?"}
              </div>
              <button
                className="post-delete-btn"
                onClick={() => {
                  if (__ChangeState && ActiveType) {
                    __ChangeState(ActiveType, data).then((state) => {
                      if (state) {
                        setActiveType(undefined);
                      }
                    });
                  }
                }}
              >
                {ActiveType === "reject"
                  ? "거절하기"
                  : ActiveType === "select"
                  ? "선정하기"
                  : ActiveType === "block"
                  ? "강퇴하기"
                  : "복귀하기"}
              </button>
            </div>
          </>
        ) : undefined}
      </div>
    </div>
  );
};

export default FinishSelectCard;
